const DIGITS = /^\d+$/;
const DECIMAL_SEPARATOR = '.';
const MAX_DECIMAL_PARTS = 2;

/**
 * A plain non-negative decimal as the backend serialises Money amounts and BigDecimal rates:
 * digits, optionally followed by `.` and more digits ("990.00", "3.2"), never an exponent.
 */
export function isNonNegativeDecimal(value: string) {
  const parts = value.split(DECIMAL_SEPARATOR);

  return parts.length <= MAX_DECIMAL_PARTS && parts.every((part) => DIGITS.test(part));
}
